<template>
  <SPrivacyPolicy />
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'PrivacyPolicyPage',
  metaInfo() {
    return getMetaInfo((this as { pageData?: { Seo?: unknown } }).pageData?.Seo);
  },
};
</script>

<script setup lang="ts">
import { SPrivacyPolicy } from '@slg/web-customer-shared';
</script>

<style lang="scss">
.privacy-policy-page-container {
  margin: 0 auto;
  min-height: 400px;
}
</style>
